import React, {ReactElement} from 'react';
import {graphql, useStaticQuery} from 'gatsby';
import {cx} from '@emotion/css';
import {GatsbyImage, IGatsbyImageData} from 'gatsby-plugin-image';

import styles from './Avatar.styles';

interface AvatarProps {
  image?: {
    title: string;
    gatsbyImageData: IGatsbyImageData;
  };
  className?: string;
}

function Avatar({image, className}: AvatarProps): ReactElement {
  const defaultAvatar = useStaticQuery(graphql`
    query {
      contentfulAsset(contentful_id: {eq: "1f7XOVQ2Sxty3u3mkloCAz"}) {
        title
        gatsbyImageData(
          width: 128
          placeholder: BLURRED
          formats: [AUTO, WEBP]
          resizingBehavior: NO_CHANGE
          quality: 80
        )
      }
    }
  `);

  return (
    <div className={cx(styles.container, className)}>
      <GatsbyImage
        className={cx(styles.image)}
        image={image?.gatsbyImageData || defaultAvatar.contentfulAsset.gatsbyImageData}
        alt={image?.title || defaultAvatar.contentfulAsset.title}
      />
    </div>
  );
}

export default Avatar;
